export default __webpack_public_path__ + "static/media/whatis3.d7666b7c.png";